import IconArrowAirplane from "@Icons/arrows/IconArrowAirplane";
import {Colors} from "@Styles/Colors.style";
import Translation from "@Translation/components/Translation";

interface TableScrollProps {
    scrollLeft: () => void;
    scrollRight: () => void;
    isLeftDisabled: boolean;
    isRightDisabled: boolean;
}

export const TableScroll = (props: TableScrollProps) => {
    const {
        scrollLeft,
        scrollRight,
        isLeftDisabled,
        isRightDisabled,
    } = props;

    return (
        <>
            <div
                onClick={scrollLeft}
                className={`travel-table-arrow travel-table-arrow__left ${isLeftDisabled ? 'travel-table-arrow__disabled' : ''}`}
            >
                <IconArrowAirplane
                    fill={isLeftDisabled ? Colors.neutralDarkColor : Colors.primaryColor}
                    direction="left"
                />
                <Translation
                    translationKey="sys.scroll_left"
                    styleText="firstUpper"
                />
            </div>
            <div
                onClick={scrollRight}
                className={`travel-table-arrow travel-table-arrow__right ${isRightDisabled ? 'travel-table-arrow__disabled' : ''}`}
            >
                <Translation
                    translationKey="sys.scroll_right"
                    styleText="firstUpper"
                />
                <IconArrowAirplane
                    fill={isRightDisabled ? Colors.neutralDarkColor : Colors.primaryColor}
                    direction="right"
                />
            </div>
        </>
    )
}